import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';
import { ImagingClient } from 'business/models/Models';
import { getPlainDto } from 'transformers/utils';

export default class ImagerQuotaService extends BaseService {
  async getAllImagerQuota() {
    const client: ImagingClient = ModelFactory(ImagingClient, false, true);
    const data = await client.getAllImagerQuota();
    return getPlainDto(data);
  }

  async saveImagerQuota(imagerQuotaDTOList) {
    const client: ImagingClient = ModelFactory(ImagingClient, false, true);
    const data = await client.saveImagerQuota(imagerQuotaDTOList);
    return getPlainDto(data);
  }
}
